"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extend = void 0;
var is_plain_object_1 = require("./is-plain-object");
function extend() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var deep = typeof sources[0] === 'boolean' ? sources.shift() : false, target = sources.shift(), length = sources.length;
    if (!target)
        return {};
    if (!length)
        return extend(deep, {}, target);
    for (var i = 0; i < length; i++) {
        var source = sources[i];
        for (var key in source) {
            if (deep && (Array.isArray(source[key]) || is_plain_object_1.isPlainObject(source[key]))) {
                if (!target[key] || target[key].constructor !== source[key].constructor)
                    target[key] = new source[key].constructor();
                extend(deep, target[key], source[key]);
            }
            else {
                target[key] = source[key];
            }
        }
    }
    return target;
}
exports.extend = extend;
//# sourceMappingURL=extend.js.map